<template>
  <div class="alipay-container">
    <div class="breadcrumb-wrapper">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/Welcome' }">
          <i class="el-icon-s-home"></i> 首页
        </el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/brandList' }">商标管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{ id ? '编辑商标' : '新增商标' }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <el-card class="alipay-card" shadow="hover">
      <div slot="header" class="card-header-title">
        <span>{{ id ? '编辑商标信息' : '新增商标信息' }}</span>
      </div>

      <el-form :model="form" :rules="rules" ref="formRef" label-width="120px" label-position="right" size="mini">
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="商标中文名称" prop="name">
              <el-input v-model="form.name" placeholder="请输入商标标准中文名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="注册号" prop="reg_sn">
              <el-input v-model="form.reg_sn" placeholder="国内注册号/国外当地注册号"></el-input>
            </el-form-item>
          </el-col>

          <!-- 多组绑定类目 -->
          <el-col :span="24">
            <el-form-item label="注册类目" prop="bindList" required>
              <div class="bind-card-wrap">
                <div class="bind-header">
                  <span class="title">已绑定大类&小类（支持多组）</span>
                  <el-button size="small" type="primary" icon="el-icon-plus" @click="openBindDialog">添加类目</el-button>
                </div>
                <div class="bind-table" v-if="form.bindList.length > 0">
                  <el-table :data="form.bindList" border size="small" max-height="260">
                    <el-table-column label="商标大类" width="180" align="center">
                      <template slot-scope="scope">
                        <el-tag size="mini" type="primary">{{ scope.row.bigName }}</el-tag>
                      </template>
                    </el-table-column>
                    <el-table-column label="所选小类" min-width="320">
                      <template slot-scope="scope">
                        <el-tag v-for="sid in scope.row.smallIds" :key="sid" size="mini" effect="light" style="margin:0 4px 4px 0">
                          {{ getSmallName(sid, scope.row.bigId) }}
                        </el-tag>
                      </template>
                    </el-table-column>
                    <el-table-column label="操作" width="100" align="center" fixed="right">
                      <template slot-scope="scope">
                        <el-button size="mini" type="text" icon="el-icon-edit" @click="editBindItem(scope.$index)">编辑</el-button>
                        <el-button size="mini" type="text" icon="el-icon-delete" style="color:#f56c6c" @click="delBindItem(scope.$index)">删除</el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
                <div class="empty-tip" v-else>
                  <i class="el-icon-folder-opened"></i>
                  <p>暂无绑定类目，请点击添加</p>
                </div>
              </div>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="申请日期" prop="apply_date">
              <el-date-picker  value-format="yyyy-MM-dd"  v-model="form.apply_date" type="date" placeholder="申请日期" style="width:100%"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="所属行业">
              <el-cascader v-model="form.industry_id" :props="industryProps" :options="industryOptions" placeholder="选择行业" style="width:100%"></el-cascader>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="联系人" prop="cont_name">
              <el-input v-model="form.cont_name" placeholder="对接联系人"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系电话" prop="telephone">
              <el-input v-model="form.telephone" placeholder="11位手机号"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item label="商标图样" >
              <el-upload
                action="/api/upload"
                list-type="picture-card"
                :limit="1"
                :on-success="handleUploadSuccess"
                :file-list="fileList"
                :on-remove="handleRemoveImg"
              >
                <i class="el-icon-plus"></i>
              </el-upload>
              <div class="tip-text">jpg/png，≤2M，白底清晰图样</div>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="商标状态">
              <el-select v-model="form.status" disabled style="width:100%">
                <el-option label="待审核" :value="0"></el-option>
                <el-option label="已注册" :value="1"></el-option>
                <el-option label="驳回" :value="2"></el-option>
                <el-option label="续展中" :value="3"></el-option>
                <el-option label="失效" :value="4"></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item label="中文注册地址">
              <el-input v-model="form.address" type="textarea" rows="3" placeholder="详细注册地址"></el-input>
            </el-form-item>
          </el-col>

          <!-- 国际商标折叠区块 -->
          <el-col :span="24">
            <el-collapse v-model="activeCollapse">
              <el-collapse-item title="国际商标信息（国外/马德里填写）" name="international">
                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-form-item label="商标类型" prop="brand_type">
                      <el-select v-model="form.brand_type" @change="changeBrandType">
                        <el-option label="国内商标" :value="1"></el-option>
                        <el-option label="单一国外商标" :value="2"></el-option>
                        <el-option label="马德里国际商标" :value="3"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12" v-if="form.brand_type != 3">
                    <el-form-item label="注册国家(ST.3)" prop="country_code">
                      <el-select v-model="form.country_code">
                        <el-option label="中国 CN" value="CN"></el-option>
                        <el-option label="美国 US" value="US"></el-option>
                        <el-option label="日本 JP" value="JP"></el-option>
                        <el-option label="韩国 KR" value="KR"></el-option>
                        <el-option label="德国 DE" value="DE"></el-option>
                        <el-option label="法国 FR" value="FR"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12" v-if="form.brand_type === 3">
                    <el-form-item label="马德里国际注册号" prop="int_reg_sn">
                      <el-input v-model="form.int_reg_sn"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12" v-if="form.brand_type === 3">
                    <el-form-item label="多指定成员国" prop="designated_countries">
                      <el-select v-model="form.designated_countries" multiple collapse-tags>
                        <el-option label="美国 US" value="US"></el-option>
                        <el-option label="日本 JP" value="JP"></el-option>
                        <el-option label="德国 DE" value="DE"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="基础母案注册号">
                      <el-input v-model="form.basic_reg_sn"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="有效期截止日" prop="expire_date">
                      <el-date-picker  value-format="yyyy-MM-dd" v-model="form.expire_date" type="date"></el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="优先权日期">
                      <el-date-picker  value-format="yyyy-MM-dd" v-model="form.priority_date" type="date"></el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col :span="24">
                    <el-form-item label="英文商标名称" prop="mark_name_en">
                      <el-input v-model="form.mark_name_en"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="24">
                    <el-form-item label="原始外文商标名">
                      <el-input v-model="form.mark_name_origin"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="持有人英文">
                      <el-input v-model="form.holder_en"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="持有人外文原名">
                      <el-input v-model="form.holder_origin"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="24">
                    <el-form-item label="英文注册地址">
                      <el-input v-model="form.address_en" type="textarea" rows="2"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="24">
                    <el-form-item label="图样外文说明">
                      <el-input v-model="form.tm_desc" type="textarea" rows="2"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-collapse-item>
            </el-collapse>
          </el-col>

          <el-col :span="24">
            <el-form-item label="内部备注">
              <el-input v-model="form.remark" type="textarea" rows="3"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <div class="form-footer">
          <el-button size="medium" @click="$router.go(-1)">返回列表</el-button>
          <el-button size="medium" type="primary" @click="submitForm">保存提交</el-button>
        </div>
      </el-form>
    </el-card>

    <!-- 添加/编辑类目弹窗 -->
    <el-dialog
      :title="bindDialogTitle"
      :visible.sync="bindDialogVisible"
      width="560px"
      :close-on-click-modal="false"
      class="alipay-dialog"
      @closed="resetBindForm"
    >
      <el-form :model="bindForm" ref="bindFormRef" label-width="110px">
        <el-form-item label="选择商标大类" prop="bigId">
          <el-select v-model="bindForm.bigId" placeholder="选择1-45大类" @change="onBindBigChange" style="width:100%">
            <el-option v-for="item in categoryBigList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="选择小类" prop="smallIds">
          <el-select
            v-model="bindForm.smallIds"
            multiple
            collapse-tags
            placeholder="先选大类"
            :disabled="!bindForm.bigId"
            style="width:100%"
          >
            <el-option v-for="item in currentSmallList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="bindDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="saveBindItem">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'tradeMarkForm',
  data() {
    return {
      id: '',
      activeCollapse: ['international'],
      categoryBigList: [],
      categorySmallMap: {},
      currentSmallList: [],
      industryOptions: [],
      industryProps: { value: 'id', label: 'name', children: 'children' },
      fileList: [],

      form: {
        name: '',
        reg_sn: '',
        bindList: [],
        apply_date: '',
        cont_name: '',
        telephone: '',
        industry_id: [],
        img_url: '',
        address: '',
        status: 0,
        remark: '',
        brand_type: 1,
        country_code: 'CN',
        designated_countries: [],
        int_reg_sn: '',
        basic_reg_sn: '',
        expire_date: '',
        renew_date: '',
        priority_date: '',
        mark_name_en: '',
        mark_name_origin: '',
        holder_en: '',
        holder_origin: '',
        address_en: '',
        tm_desc: '',
        lang_origin: 'en'
      },

      bindDialogVisible: false,
      bindDialogTitle: '添加注册类目',
      editBindIndex: -1,
      bindForm: { bigId: '', bigName: '', smallIds: [] },

      rules: {
        name: [{ required: true, message: '请输入商标名称', trigger: 'blur' }],
        reg_sn: [{ required: true, message: '请输入注册号', trigger: 'blur' }],
        bindList: [{ required: true, message: '至少绑定一组类目', trigger: 'change' }],
        apply_date: [{ required: true, message: '请选择申请日期', trigger: 'change' }],
        cont_name: [{ required: true, message: '请填写联系人', trigger: 'blur' }],
        telephone: [
          { required: true, message: '请填写手机号', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '手机号格式错误' }
        ],
        img_url: [{ required: true, message: '请上传商标图样', trigger: 'blur' }],
        brand_type: [{ required: true, message: '请选择商标类型', trigger: 'change' }],
        country_code: [{ required: true, message: '请选择注册国家', trigger: 'change' }],
        int_reg_sn: [{ required: true, message: '马德里商标必须填写国际注册号', trigger: 'blur', triggerType: 'change', when: () => this.form.brand_type === 3 }]
      }
    }
  },
  created() {
    this.id = this.$route.query.id
    this.getDictData()
    if (this.id) this.loadEditData()
  },
  methods: {
    // 拉取类目、行业字典
    async getDictData() {
      const companyId = sessionStorage.getItem('company_id')
      const res = await this.$axios.findBrandCategoryTree({ company_id: companyId, access_token: sessionStorage.getItem('token') })
      if (res.code === 200) {
        const tree = res.data
        this.categoryBigList = tree.filter(i => i.parent_id === 0)
        const map = {}
        tree.forEach(big => {
          if (big.parent_id === 0 && big.children) {
            map[big.id] = big.children
          }
        })
        this.categorySmallMap = map
      }
      // 模拟行业
      this.industryOptions = [
        { id: 1, name: '互联网', children: [{ id: 11, name: '电商' }, { id: 12, name: '软件' }] },
        { id: 2, name: '实体', children: [{ id: 21, name: '餐饮' }, { id: 22, name: '零售' }] }
      ]
    },

    // 类目弹窗
    openBindDialog() {
      this.bindDialogTitle = '添加注册类目'
      this.editBindIndex = -1
      this.bindDialogVisible = true
    },
    editBindItem(index) {
      const item = this.form.bindList[index]
      this.editBindIndex = index
      this.bindDialogTitle = '修改类目'
      this.bindForm = { bigId: item.bigId, bigName: item.bigName, smallIds: [...item.smallIds] }
      this.currentSmallList = this.categorySmallMap[item.bigId] || []
      this.bindDialogVisible = true
    },
    delBindItem(index) {
      this.form.bindList.splice(index, 1)
    },
    onBindBigChange(bigId) {
      const big = this.categoryBigList.find(i => i.id === bigId)
      this.bindForm.bigName = big.name
      this.currentSmallList = this.categorySmallMap[bigId] || []
      this.bindForm.smallIds = []
    },
    saveBindItem() {
      this.$refs.bindFormRef.validate(valid => {
        if (!valid) return
        const obj = { bigId: this.bindForm.bigId, bigName: this.bindForm.bigName, smallIds: this.bindForm.smallIds }
        if (this.editBindIndex > -1) {
          this.form.bindList.splice(this.editBindIndex, 1, obj)
        } else {
          const repeat = this.form.bindList.some(v => v.bigId === obj.bigId)
          if (repeat) return this.$message.warning('该大类已添加')
          this.form.bindList.push(obj)
        }
        this.bindDialogVisible = false
      })
    },
    resetBindForm() {
      this.bindForm = { bigId: '', bigName: '', smallIds: [] }
      this.currentSmallList = []
      this.$refs.bindFormRef?.resetFields()
    },
    getSmallName(sid, bid) {
      const list = this.categorySmallMap[bid] || []
      const row = list.find(i => i.id === sid)
      return row ? row.name : ''
    },

    // 上传
    handleUploadSuccess(res) {
      this.form.img_url = res.data.url
      this.fileList = [{ url: res.data.url }]
      this.$message.success('上传成功')
    },
    handleRemoveImg() {
      this.form.img_url = ''
    },

    // 切换商标类型
    changeBrandType() {
      if (this.form.brand_type === 1) {
        this.form.country_code = 'CN'
        this.form.designated_countries = []
        this.form.int_reg_sn = ''
      } else if (this.form.brand_type === 2) {
        this.form.designated_countries = []
        this.form.int_reg_sn = ''
      }
    },

    // 编辑回显
    async loadEditData() {
      const token = sessionStorage.getItem('token')
      const cid = sessionStorage.getItem('company_id')
      // 基础信息
      const infoRes = await this.$axios.findBrandOne({ id: this.id, company_id: cid, access_token: token })
      if (infoRes.code !== 200) return
      this.form = infoRes.data
      if (this.form.img_url) this.fileList = [{ url: this.form.img_url }]
      // 绑定类目
      const bindRes = await this.$axios.findBrandBind({ brand_id: this.id, company_id: cid, access_token: token })
      if (bindRes.code === 200) this.form.bindList = bindRes.data
    },

    // 提交
    submitForm() {
      this.$refs.formRef.validate(async valid => {
        if (!valid) return
        const token = sessionStorage.getItem('token')
        const cid = sessionStorage.getItem('company_id')
        const params = { ...this.form, access_token: token, company_id: cid }
        let res
        if (this.id) {
          params.id = this.id
          res = await this.$axios.brandEdit(params)
        } else {
          res = await this.$axios.brandAdd(params)
        }
        if (res.code === 200) {
          this.$message.success(this.id ? '修改成功' : '新增成功')
          this.$router.push('/brandList')
        } else {
          this.$message.error(res.msg)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.alipay-container {
  padding: 16px 24px;
  background: #f5f7fa;
  min-height: calc(100vh - 60px);
}
.breadcrumb-wrapper { margin-bottom: 16px; }
.alipay-card {
  border-radius: 16px;
  ::v-deep .el-card__header {
    padding: 18px 24px;
    background: linear-gradient(135deg, #1677ff, #4096ff);
  }
  .card-header-title { color: #fff; font-weight: 500; font-size: 16px; }
  ::v-deep .el-card__body { padding: 24px 30px; }
}
.bind-card-wrap {
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 16px;
  background: #fff;
}
.bind-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  .title { font-size: 14px; font-weight: 500; }
}
.empty-tip {
  text-align: center;
  padding: 40px 0;
  color: #c0c4cc;
  i { font-size: 48px; margin-bottom: 10px; }
}
.tip-text { font-size: 12px; color: #8c8f98; margin-top: 8px; }
.form-footer {
  display: flex;
  justify-content: center;
  gap: 16px;
  margin-top: 36px;
  .el-button { width: 120px; border-radius: 24px; }
}
.alipay-dialog {
  ::v-deep .el-dialog { border-radius: 20px; }
  ::v-deep .el-dialog__header { background: linear-gradient(135deg, #1677ff, #4096ff); }
  ::v-deep .el-dialog__title { color: #fff; }
}
.dialog-footer { display: flex; justify-content: flex-end; gap: 12px; }
</style>